import validate from 'validate.js'
import equalityTo from './equalityTo'
import nonEqualityTo from './nonEqualityTo'

validate.options = {
  fullMessages: false
}

validate.validators.presence.options = {
  message: "Поле обязательно для заполнения",
  allowEmpty: false
}

validate.validators.email.options = {
  message: "Некорректный адрес электронной почты"
}

validate.validators.equalityTo = equalityTo
validate.validators.nonEqualityTo = nonEqualityTo

export default validate



// WEBPACK FOOTER //
// ./src/validators/config.js